import styled from 'styled-components';
import { Box } from '../../../../../../../../../../CommonComponents/OPL/Box/Box';

export const EdgeWrapper = styled(Box)<{ showTopLine?: boolean }>(
  ({ theme, showTopLine = true }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '&:after, &:before': {
      content: '""',
      width: '1px',
      backgroundColor: theme.colors.neutral[400],
      flexGrow: 1,
    },

    '&:before': {
      marginBottom: theme.space[8],
      minHeight: showTopLine ? '50px' : 0,
    },

    '&:after': {
      marginTop: theme.space[8],
      minHeight: '50px',
    },

    '@media print': {
      '&:before': {
        marginBottom: theme.space[4],
        minHeight: showTopLine ? '15px' : 0,
      },

      '&:after': {
        marginTop: theme.space[4],
        minHeight: '15px',
      },
    },
  }),
);
